var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdministrationV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 15.8334C1.66663 14.7552 1.92801 13.6931 2.42848 12.7381C2.92895 11.7832 3.65357 10.9638 4.54021 10.3503C5.42685 9.73688 6.44905 9.34762 7.51915 9.21593C8.58925 9.08424 9.67533 9.21406 10.6842 9.59425",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33317 9.16536C10.6344 9.16536 12.4998 7.29988 12.4998 4.9987C12.4998 2.69751 10.6344 0.832031 8.33317 0.832031C6.03198 0.832031 4.1665 2.69751 4.1665 4.9987C4.1665 7.29988 6.03198 9.16536 8.33317 9.16536Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6006 10.2998C14.8626 10.2998 15.1195 10.3697 15.3467 10.5L15.3477 10.499L18.1484 12.0996L18.1514 12.1016C18.3791 12.2331 18.5686 12.4218 18.7002 12.6494C18.8318 12.8772 18.9011 13.1363 18.9014 13.3994V16.6006L18.8887 16.7969C18.8629 16.9913 18.799 17.1797 18.7002 17.3506C18.5686 17.5782 18.3791 17.7669 18.1514 17.8984L18.1484 17.9004L15.3477 19.501L15.3467 19.5C15.1195 19.6303 14.8626 19.7002 14.6006 19.7002C14.3383 19.7002 14.0809 19.6307 13.8535 19.5V19.501L11.0527 17.9004L11.0498 17.8984C10.8221 17.7669 10.6326 17.5782 10.501 17.3506C10.3693 17.1228 10.3001 16.8637 10.2998 16.6006V13.3994L10.3135 13.2031C10.3393 13.0087 10.4022 12.8203 10.501 12.6494C10.6326 12.4218 10.8221 12.2331 11.0498 12.1016L11.0527 12.0996L13.8535 10.499V10.5C14.0809 10.3693 14.3383 10.2998 14.6006 10.2998Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6008 16.5991C15.4847 16.5991 16.2011 15.8826 16.2011 14.9988C16.2011 14.1149 15.4847 13.3984 14.6008 13.3984C13.717 13.3984 13.0005 14.1149 13.0005 14.9988C13.0005 15.8826 13.717 16.5991 14.6008 16.5991Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministrationV2);
export default __webpack_public_path__ + "static/media/administrationV2.4f52b2b9d3e56014f97a5b2f75ca73b0.svg";
export { ForwardRef as ReactComponent };